import assign from 'lodash.assign';
import { DROP_SUCCESS, GET_ALL_DRAG, ADD_DRAG_ELEMENT } from './action';
import {Types} from '../Types';

const initialState = {
    dragElements: [
        {
            type: Types.ONE,
            image: "staket_markisvav_G2.svg",
            height: '90',
            width: '200',
            name: "SEKTION - 2 M"
        },
        {
            type: Types.THREE,
            image: "staket_markisvav_G1.svg",
            height: '90',
            width: '100',
            name: "SEKTION - 1 M"
        },
        {
            type: Types.TWO,
            image: "staket_forhjot_G2.svg",
            height: '160',
            width: '200',
            name: "FÖRHÖJD SEKTION - 2 M"
        },
        {
            type: Types.FOUR,
            image: "staket_forhjot_G1.svg",
            height: '160',
            width: '100',
            name: " FÖRHÖJD SEKTION - 1 M"
        }
    ],
    dragedElements: []
};


export default function Drag(state = initialState, action) {
    switch(action.type){
        case DROP_SUCCESS:
            return Object.assign({}, state, {
                'user' : action.user,
                'loggedIn': true,
                'token': action.token
            });
        
        case GET_ALL_DRAG: {
            return state;
        }
        case ADD_DRAG_ELEMENT: {
            return Object.assign({}, state,{
                dragedElements: [...state.dragedElements, action.data]
            })
        }
        default: 
        return state;
    }
    
}


// WEBPACK FOOTER //
// ./src/Services/Drag/reducer.js